<template>
  <div class="notes_view_for_wrp">
    <div class="notes_view_inner_wrp">
      <div class="notes_view_inner_bg">
        <div class="notes_view_header_wrp">
          <div class="row align-items-center">
            <div class="col">
              <ul class="notes_view_header_list">
                <li><i class="fa fa-compress" aria-hidden="true" @click="backToNormalViewMethod()"></i></li>
              </ul>
            </div>
            <div class="col">
              <ul class="notes_view_header_list justify-content-end">
                <li v-if="fullViewModeEditable"><i class="fa fa-pencil" aria-hidden="true" @click="fullViewModeEditableMethod()"></i></li>
                <li v-else><i class="fa fa-check" aria-hidden="true" @click="fullViewModeEditableMethod()"></i></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="notes_view_body_wrp note_for_textarea_styling">
          <template v-if="fullViewModeEditable">
            <h2 class="notes_view_title">{{notesViewData.title}}</h2>
            <div class="notes_view_content readonly_html_note_text" v-html="notesViewData.data"></div>
          </template>
          <template v-else>
            <template v-if="notesViewData.under_editing && notesViewData.edited_by.id != this.selfUserId">
              <span class="currently_updating_txt">{{notesViewData.edited_by.first_name}} {{notesViewData.edited_by.last_name}} is currently updating the document. Please wait for your teammate to complete their notes, after which you can update and save your changes.</span>
              <input type="text" class="title_insert_notes_textarea" v-model="notesViewData.title" readonly>
              <div v-html="notesViewData.data" class="readonly_html_note_text"></div>
            </template>
            <template v-else>
              <input type="text" class="notes_view_title" v-model="notesViewData.title" @keyup="updatedSharedNotesNotificationMethod(notesViewData.id)" @change="updatedInsertedNotesDataMethod(notesViewData.data,notesViewData.title,notesViewData.id)">
              <!-- <textarea v-model="notesViewData.data" class="notes_view_content" @keyup="updatedSharedNotesNotificationMethod(notesViewData.id)" @change="updatedInsertedNotesDataMethod(notesViewData.data,notesViewData.title,notesViewData.id)"></textarea> -->
              <vue-editor v-model="notesViewData.data" :editorToolbar="customToolbar" :value="editorData" placeholder="Description..." :config="editorOptions" @blur="updatedInsertedNotesDataMethod(notesViewData.data,notesViewData.title,notesViewData.id)" @focus="updatedSharedNotesNotificationMethod(notesViewData.id)"></vue-editor>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  bus
} from '@/main';
import { VueEditor } from "vue2-editor";
export default {
  name: 'notes-view-section',
  components: {
    VueEditor
  },
  props: ['notesViewDATA'],
  data () {
    return {
      fullViewModeEditable:true,
      notesViewData:{},
      keyUpEvent:false,
      selfUserId:'',
      editorOptions: {
        placeholder: 'Description...'
      },
      // Toolbar strictly matching the dropdown font + B, I, U, Color, Background in image
      customToolbar: [
        [{ font: [] }],
        ["bold", "italic", "underline"],
        [{ color: [] }, { background: [] }]
      ],
      editorData: '',
    }
  },
  computed: {

  },
  mounted () {
    this.notesViewData = this.notesViewDATA
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
  },
  methods: {
    backToNormalViewMethod(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('notesViewPopupBus', false);
    },
    fullViewModeEditableMethod(){
      if(this.fullViewModeEditable == true){
        this.fullViewModeEditable = false
      }else{
        this.fullViewModeEditable = true
      }
    },
    updatedInsertedNotesDataMethod(updateData,updateTitle,updateId){
      let data = {
        data:updateData,
        title:updateTitle
      }
      this.$store.dispatch('updateNewNotesDetailsFun',{data:{data:data,id:updateId}}).then((res)=>{
        this.updatedSharedNotesNotificationFalseMethod(updateId)
      }).catch((err)=>{})
    },
    updatedSharedNotesNotificationMethod(updateId){
      if(this.keyUpEvent) return;
      let data = {
        under_editing:true,
        edited_by:this.selfUserId
      }
      this.$store.dispatch('updateNewNotesDetailsFun',{data:{data:data,id:updateId}}).then((res)=>{
        this.keyUpEvent = true
      }).catch((err)=>{})
    },
    updatedSharedNotesNotificationFalseMethod(updateId){
      let data = {
        under_editing:false,
        edited_by:this.selfUserId
      }
      this.$store.dispatch('updateNewNotesDetailsFun',{data:{data:data,id:updateId}}).then((res)=>{
        this.keyUpEvent = false
      }).catch((err)=>{})
    },
    getAgainAllNotesDetailsForUpdateMethod(){
      this.$store.dispatch('getAllNotesListFun').then((res)=>{
      }).catch((err)=>{})
    },
    sharedNotesListMethod(){
      this.$store.dispatch('getAllSharedNotesListFun').then((res)=>{
      }).catch((err)=>{})
    },
  }
}
</script>

<style lang="scss" scoped>
.notes_view_for_wrp {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 1100;
  display: flex;
  justify-content: center;
  align-items: center;

  .notes_view_inner_wrp {
    width: 100%;
    max-width: 600px;
  }

  .notes_view_inner_bg {
    background: #0d0f12;
    border-radius: 8px;
    height: calc(100vh - 40px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .notes_view_header_wrp {
    padding: 8px 15px;
    background: rgba(12, 13, 18, 0.7);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.01);
    margin: 0;
    

    .notes_view_header_list {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      align-items: center;

      li {
        margin-right: 8px;
        &:last-child {
          margin-right: 0px;
        }

        .fa {
          font-size: 15px;
          color: #9ba1a6;
          cursor: pointer;
          padding:0px;
          background: #191c21;
          border: 1px solid #282c34;
          border-radius: 5px;
          width: 26px;
          height: 26px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;

          &:hover {
            background: #23272e;
            color: #ffffff;
            border-color: #3b4048;
          }

          &.fa-check {
            color: #00ca72;
            border-color: #17422b;
            background: #0d281a;

            &:hover {
              background: #113623;
              border-color: #00ca72;
            }
          }
        }
      }
    }
  }

  .notes_view_body_wrp {
    padding: 10px 20px 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .notes_view_title,
    .title_insert_notes_textarea {
      width: 100%;
      border: none;
      outline: none;
      background: transparent;
      font-size: 22px;
      font-weight: 700;
      color: #eab308;
      padding: 6px 0 10px;
      margin: 0 0 5px;
      line-height: 1.2;
      border-bottom: 1px solid rgba(255, 255, 255, 0.02);

      &:focus {
        border-bottom-color: #eab308;
      }

      &::placeholder {
        color:#5e6473;
        font-weight: 400;
      }
    }

    .notes_view_content {
      margin: 0;
      font-size: 16px;
      color: #e6edf3;
      overflow-y: auto;
      line-height: 1.5;
      padding: 8px 0 0;
      white-space: break-spaces;
      background: transparent;
      width: 100%;
      flex: 1;
    }

    .currently_updating_txt {
      margin-bottom: 10px;
      color: #a855f7;
      font-size: 14px;
      line-height: 1.4;
      display: block;
    }
  }
}

::v-deep .quillWrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    background: none;
    border: none !important;

    /* Floating Pill Dock Toolbar */
    .ql-toolbar.ql-snow {
      align-self: flex-start; /* change to 'center' if you want it centered */
      display: inline-flex;
      align-items: center;
      background: #121318 !important;
      border: 1px solid rgba(255, 255, 255, 0.02) !important;
      border-radius: 12px; /* modern rounded-box dock; use 9999px for full pill */
      padding: 2px 5px !important;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.45);
      gap: 0px;

      /* Divider groups */
      .ql-formats {
        display: inline-flex;
        align-items: center;
        margin: 0 4px 0 0 !important;
        padding-right: 8px;
        border-right: 1px solid rgba(255, 255, 255, 0.1);

        &:last-child {
          margin-right: 0 !important;
          padding-right: 0;
          border-right: none;
        }
      }

      /* Fix collapsed font & picker dropdowns */
      .ql-picker {
        color: #d1d5db;
        font-size: 13px;
        font-weight: 500;
        height: 26px;
        display: inline-flex;
        align-items: center;

        &.ql-font,
        &.ql-size,
        &.ql-header {
          width: auto;
          min-width: 95px;
        }

        .ql-picker-label {
          display: inline-flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 100%;
          padding: 0 8px;
          border-radius: 5px;
          border: none;
          outline: none;
          color: inherit;
          transition: background 0.15s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.09);

            .ql-stroke {
              stroke: #ffffff;
            }
          }

          svg {
            right: 4px;
            width: 14px;
            height: 14px;
          }
        }

        /* Fix collapsed color/background picker icons */
        &.ql-color,
        &.ql-background {
          width: 25px;
          height: 25px;

          .ql-picker-label {
            padding: 4px;
            justify-content: center;

            svg {
              position: static;
              width: 16px;
              height: 16px;
            }
          }
        }

        /* Dropdown popover list */
        .ql-picker-options {
          background-color: #17181f;
          border: 1px solid rgba(255, 255, 255, 0.12);
          border-radius: 8px;
          padding: 6px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
          margin-top: 6px;
          right: 0px;
        }

        .ql-picker-item {
          padding: 6px 12px;
          border-radius: 4px;
          color: #9ca3af;
          font-size: 13px;

          &:hover,
          &.ql-selected {
            background: #252834;
            color: #ffffff;
          }
        }
      }

      /* Toolbar Buttons (B, I, U, etc.) */
      button {
        width: 25px;
        height: 25px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        background: transparent;
        border: none;
        outline: none;
        padding: 0 !important;
        margin: 0 1px;
        transition: background 0.15s ease, color 0.15s ease;

        /* Fix default font icons like text B, I, U */
        color: #94a3b8;
        font-size: 14px;
        font-weight: 600;

        svg {
          width: 16px;
          height: 16px;
        }

        .ql-stroke {
          stroke-width: 1.8;
          transition: stroke 0.15s ease;
        }

        .ql-fill {
          transition: fill 0.15s ease;
        }

        /* Active pressed state (like the Hand icon in reference 2) */
        &.ql-active {
          background: #2a2c36 !important;
          color: #ffffff;

          .ql-stroke { stroke: #ffffff !important; }
          .ql-fill { fill: #ffffff !important; }
        }
      }
    }

    /* Content Area */
    .ql-container {
      flex: 1;
      border: 1px solid rgba(255, 255, 255, 0.02) !important;
      border-radius: 10px;
      font-size: 14px;
      line-height: 1.7;
      color: #e5e7eb;

      &.ql-snow {
        background: #111217 !important;
      }

      .ql-editor {
        padding: 18px 20px;
        min-height: 100%;

        &::-webkit-scrollbar {
            width: 4px;
            background: rgba(12, 13, 18, 0.9);
        }
        &::-webkit-scrollbar-thumb {
            background-color: #111217;
            border-radius: 10px
        }

        &.ql-blank::before {
          left: 20px !important;
          color: #4b5262 !important;
          font-style: normal;
        }
      }
    }
  }
</style>